import apiService from '../../../services/api'

export const selectContractItems = (items) => items.slice(0, 9)

export const getContractProfit = (result) => {
  if (result?.win?.profit != null && Number.isFinite(Number(result.win.profit))) return Number(result.win.profit)
  const price = Number(result?.win?.price ?? result?.win?.cost ?? 0)
  const donorsCost = Number(result?.donorsCost)
  return Number.isFinite(price) && Number.isFinite(donorsCost) && donorsCost > 0 ? (price - donorsCost) / donorsCost * 100 : null
}

export const selectRandomContractItems = (items, random = Math.random) => {
  if (items.length < 3) return []
  const count = 3 + Math.floor(random() * (Math.min(items.length, 9) - 2))
  const shuffled = [...items]
  for (let index = 0; index < count; index++) {
    const swap = index + Math.floor(random() * (shuffled.length - index))
    const item = shuffled[index]
    shuffled[index] = shuffled[swap]
    shuffled[swap] = item
  }
  return shuffled.slice(0, count)
}

export const contractGameApi = {
  getInventory: async () => {
    const response = await apiService.makeRequest('/api/contract/', { method: 'GET' })
    const items = response?.contract ?? response
    if (!Array.isArray(items)) throw new Error('Invalid contract inventory')
    return items.map((item) => ({ ...item, price: Number(item.price ?? item.cost ?? 0) }))
      .sort((a, b) => b.price - a.price)
  },
  sign: async (items) => {
    if (items.length < 3 || items.length > 9) throw new Error('Invalid contract selection')
    const response = await apiService.makeRequest('/api/contract/start/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items.map((item) => item.id))
    })
    const result = response?.contract
    if (!result?.win?.name) throw new Error('Invalid contract result')
    return { donors: result.donors ?? [], donorsCost: result.donors_cost ?? 0, win: result.win }
  }
}
